import RappidContext from "./rappid-context";
import { SubdiagramNavigationHistory } from "../services/subdiagram-navigation-history";
import { updateVisibleStates } from "../subdiagram-viewer";
import { deselectAll } from "../mvc/base/utils";
import { StateView } from "../mvc/state";
import { ModelEventBus } from "../../..";

export default class MouseNavigationController {
  private navigationHistory: SubdiagramNavigationHistory;

  constructor(private context: RappidContext) {
    this.navigationHistory = new SubdiagramNavigationHistory();
    this.context.mouseNavigationController = this;
  }

  activate() {
    window.addEventListener("mousedown", this.preventBrowserNavigation.bind(this), true);
    window.addEventListener("mouseup", this.preventBrowserNavigation.bind(this), true);
    window.addEventListener("auxclick", this.preventBrowserNavigation.bind(this), true);

    const paperElement = this.context.paper.el;
    paperElement.addEventListener("mousedown", this.handleMouseButton.bind(this), true);
    paperElement.addEventListener("mouseup", this.handleMouseButton.bind(this), true);
    paperElement.addEventListener("auxclick", this.handleMouseButton.bind(this), true);

    ModelEventBus.on("modelLoaded", (_) => {
      this.clearHistory();
    });
  }

  deactivate() {
    window.removeEventListener("mousedown", this.preventBrowserNavigation.bind(this), true);
    window.removeEventListener("mouseup", this.preventBrowserNavigation.bind(this), true);
    window.removeEventListener("auxclick", this.preventBrowserNavigation.bind(this), true);

    const paperElement = this.context.paper.el;
    paperElement.removeEventListener("mousedown", this.handleMouseButton.bind(this), true);
    paperElement.removeEventListener("mouseup", this.handleMouseButton.bind(this), true);
    paperElement.removeEventListener("auxclick", this.handleMouseButton.bind(this), true);

    ModelEventBus.off("modelLoaded");
  }

  private handleMouseButton(evt: MouseEvent) {
    // Button 3 = back, Button 4 = forward
    if (evt.button === 3 || evt.button === 4) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();

      if (evt.type === "auxclick") {
        if (evt.button === 3) {
          this.goBack();
        } else if (evt.button === 4) {
          this.goForward();
        }
      }
      return false;
    }
  }

  private preventBrowserNavigation(evt: MouseEvent) {
    if (evt.button === 3 || evt.button === 4) {
      evt.preventDefault();
    }
  }

  private goBack() {
    if (this.navigationHistory.canGoBack()) {
      const view = this.navigationHistory.goBack();
      updateVisibleStates(this.context, view);
      deselectAll(this.context, true);
      this.navigationHistory.completeNavigation();
    }
  }

  private goForward() {
    if (this.navigationHistory.canGoForward()) {
      const view = this.navigationHistory.goForward();
      updateVisibleStates(this.context, view);
      deselectAll(this.context, true);
      this.navigationHistory.completeNavigation();
    }
  }

  public trackNavigation(view: StateView | null) {
    this.navigationHistory.navigate(view);
  }

  public clearHistory() {
    this.navigationHistory.clear();
  }
}
